import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { exportImage } from '@progress/kendo-drawing';
import $ from "jquery";

var optionsTipoVasilha = [];

var optionsTipoRotulo = [
  { text: 'Rótulo', value: 1 },
  { text: 'Contra Rótulo', value: 2 }
];

class DropDownCellRotulo extends Component {
  
  static getAllData() {

    (async () => {

      optionsTipoVasilha = [];

      // const data = {"IDInstalacaoVinica" : $('#instal_vinica_auto').val().split('!')[0]}
      // const TipoVasilha = await services.apiCall.requestApi(
      //     "/Fiscalizacao/GetTipoVasilha",
      //     data,
      //     "get"
      // );

      var TipoRotulo = {text: "Rótulo",
                        text: "Contra Rótulo"}


      // if(TipoRotulo != null){
      //   TipoRotulo.map((tipo) => (
      //     optionsTipoVasilha.push({text: tipo.text, value: tipo.text})
      //   ));


      // }
    })();


  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });
  }
  
  
  render() {
    console.log("Tipo de rotulooooooooo drop")
    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];
    if(dataValue != null && dataValue !=  undefined && dataValue != ""){
      if(dataValue.text == "Rótulo"){
        dataValue.value = 1
      }else{
        dataValue.value = 2
      }
    }
    
    // this.getAllData();

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={optionsTipoRotulo.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={optionsTipoRotulo}
              textField="text"
              id='id-DropDownCellTipoRotulo'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
    
}

export default DropDownCellRotulo;